import React, { memo, useEffect, useState } from 'react'
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import reel from '../../../assets/images/reel.jpg'
import reel2 from '../../../assets/images/reel2.jpg'
import Carousel from 'react-material-ui-carousel';
import { customStyles } from '../../../styles';
import { RegularText, SmallText, SubTitle, Title } from '../../helpers';
import { Stack } from '@mui/material';
// import { autoPlay } from 'react-swipeable-views-utils';

const images = [
  {
    image: reel,
    caption: 'La energia que',
    caption2: 'mueve familias'
  },
  {
    image: reel2,
    caption: 'Global gas es',
    caption2: 'La energia del amor',
  },
]


function CarouselImages () {
  return (
    <Carousel indicators={false} interval={5000} autoPlay sx={{ marginBottom: 3 }} className="carousel__container">
      {
        images.map(item => (
          <Box sx={{ position: 'relative', borderRadius: 2, overflow: 'hidden' }} key={item.caption}>
            <img src={ item.image } alt={ item.caption }className="carousel__container"  width="100%"  style={{ objectFit: 'cover',  }}/>
            <Paper sx={{ 
                width: '100%',
                position: 'absolute', 
                color: customStyles.colors.lightColor,
                left: 0,
                bottom: 0,
                // transform: 'translateY(-50%)',
                padding: 2,
                bgcolor: 'rgba(0,0,0,.4)'
                }}>
                <Stack spacing={0}>
                  <RegularText text={item.caption.toUpperCase()} align='center' color={customStyles.colors.backgroundColor} />
                  <SubTitle text={item.caption2.toUpperCase()} align='center' color={customStyles.colors.backgroundColor} bold/>
                </Stack> 
            </Paper>
          </Box>
        ))
      }
    </Carousel>
    // <img src={ images[0].image } alt={ images[0].caption } width="100%" height={200}  style={{ objectFit: 'cover' }}/>
  )
}

export default memo(CarouselImages)
